



// todo: separate backedn security, etc (separate fiels for each cncern or each part)


// security: frontend

// same function in backend
function quick_dirty_string_checksum(str) {
  // const { verify } = require('crypto');
  // hash
  const intval = Array.from(str).map(c => c.charCodeAt(0)).reduce((a, b) => a + b, 0) % 97;
  return intval + '';
}

export default quick_dirty_string_checksum;
